
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import * as Sentry from "@sentry/react"
// import { FirebaseProvider } from '@/context/FirebaseProvider.tsx'; // Removed

// Initialize Sentry
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

// Error boundary for handling Firebase initialization errors
const renderApp = () => {
  try {
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        {/* FirebaseProvider is now in App.tsx */}
        <App />
      </React.StrictMode>,
    )
  } catch (error) {
    console.error('Failed to render application:', error);
    
    // Render a helpful error message instead of a blank screen
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.innerHTML = `
        <div style="font-family: system-ui, sans-serif; padding: 2rem; max-width: 600px; margin: 0 auto;">
          <h1 style="color: #e11d48;">Application Error</h1>
          <p>We couldn't load the application due to a configuration issue.</p>
          <p>If you're the developer:</p>
          <ol style="margin-top: 1rem;">
            <li>Check that you've created a <code>.env</code> file with the correct Firebase configuration.</li>
            <li>Verify that all required environment variables are properly set.</li>
            <li>Restart your development server after updating environment variables.</li>
          </ol>
          <div style="margin-top: 2rem; color: #64748b; font-size: 0.875rem;">
            <p>Error details: ${error instanceof Error ? error.message : 'Unknown error'}</p>
          </div>
        </div>
      `;
    }
  }
};

renderApp();
